import { MediaObject, Stack, Viewport, Text, useDevice } from '@treatwell/ui';
import React from 'react';
import styles from './Step.module.css';

type Props = {
  icon: string;
  label: string;
  description: string;
};

export const Step = ({ icon, label, description }: Props) => {
  const { isMobile, isDesktop } = useDevice();
  return (
    <>
      <Viewport device={['mobile', 'tablet']} serverRender={isMobile}>
        <MediaObject space="lg">
          <img src={icon} alt="" width={48} height={48} />
          <Stack space="xs">
            <Text as="h3" type="captionHeavy" className={styles.label}>
              {label}
            </Text>
            <Text as="p" type="body" className={styles.description}>
              {description}
            </Text>
          </Stack>
        </MediaObject>
      </Viewport>
      <Viewport device="desktop" serverRender={isDesktop}>
        <Stack space="xl">
          <img src={icon} alt="" width={64} height={64} />
          <Stack space="md">
            <Text as="h3" type="lgHeader" className={styles.label}>
              {label}
            </Text>
            <Text as="p" type="body" className={styles.description}>
              {description}
            </Text>
          </Stack>
        </Stack>
      </Viewport>
    </>
  );
};
